import { authHeader } from "@/_helpers/auth-header";
import { handleResponse } from "@/_helpers/handle-response";
import axios from "axios";

axios.defaults.baseURL = process.env.VUE_APP_API_ITTENTION;

export const projectService = {
  createProject,
  getProjects,
  getProject,
  delProject
  // setProject,
};

function createProject(data) {
  const requestOptions = {
    method: "post",
    url: "/projects/api/v1/project/",
    data: {
      name: data.name,
      parent: data.parent
    },
    headers: authHeader()
  };
  
  return axios(requestOptions)
    .then(handleResponse)
    .catch(error => {
      
    });
}

function getProjects(limit = -1, offset = 0) {
  return new Promise((resolve, reject) => {

  const requestOptions = {
    method: "get",
    url: "/projects/api/v1/project/",
    params: {
      limit: limit,
      offset: offset
    },
    headers: authHeader()
  };
    axios(requestOptions)
    .then(handleResponse => {
      resolve(handleResponse);
    })
    .catch(error => {
      reject(error); 
    });
  });
}

// project get one

function getProject(uuid) {
  const requestOptions = {
    method: "get",
    url: "/projects/api/v1/project/" + uuid,
    headers: authHeader()
  };

  return axios(requestOptions)
    .then(handleResponse)
    .catch(error => {
      
    });
}

function delProject(uuid) {
  const requestOptions = {
    method: "delete",
    url: "/projects/api/v1/project/" + uuid,
    headers: authHeader()
  };

  return axios(requestOptions)
    .then(handleResponse)
    .catch(error => {
      
    });
}
